import { render, staticRenderFns } from "./collect-detail.vue?vue&type=template&id=6e586d28&scoped=true&"
import script from "./collect-detail.vue?vue&type=script&lang=js&"
export * from "./collect-detail.vue?vue&type=script&lang=js&"
import style0 from "./collect-detail.vue?vue&type=style&index=0&id=6e586d28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e586d28",
  null
  
)

export default component.exports